export default "__VITE_ASSET__04c8ec8e__"